import React from 'react';

import { StyleSheet } from 'react-native';

import Currency from 'components/currency';
import { A11yWrapper } from 'components/ui/a11y-wrapper';
import { CurrencyLineSkeleton } from 'pages/cart/currency-line-skeleton';
import { t } from 'state/intl/translations';
import { useUIContext } from 'state/ui';
import { primitive, spacing } from 'styles/constants';

import { Total, TotalLabel, TotalsRow } from './styled';
import { IRenderTotalsProps } from './types';

interface Cart {
  subTotalCents?: number;
}

export const SubTotal: React.FC<React.PropsWithChildren<IRenderTotalsProps>> = ({
  cart = {} as Cart,
  otherDiscountAmount,
  rewardDiscount,
  isLoading,
}) => {
  const { subTotalCents = 0 } = cart;
  const { formatCurrencyForLocale } = useUIContext();
  const subtotal = Math.max(subTotalCents, 0);

  return (
    <>
      {!!rewardDiscount &&
        (isLoading ? (
          <CurrencyLineSkeleton />
        ) : (
          <TotalsRow>
            <A11yWrapper>
              <TotalLabel color={primitive.$crunchyGreen} style={styles.rewardSavingsLabel}>
                {t('rewardSavings')}
              </TotalLabel>
            </A11yWrapper>
            <Total testID="reward-savings">
              <Currency
                prefix="- "
                amount={rewardDiscount}
                textProps={{ color: primitive.$crunchyGreen, fontSize: 'md' }}
              />
            </Total>
          </TotalsRow>
        ))}
      {!!otherDiscountAmount &&
        (isLoading ? (
          <CurrencyLineSkeleton />
        ) : (
          <TotalsRow>
            <A11yWrapper>
              <TotalLabel color={primitive.$crunchyGreen}>{t('comboOfferSavings')}</TotalLabel>
            </A11yWrapper>
            <Total testID="discount-savings">
              <Currency
                prefix="- "
                textProps={{ color: primitive.$crunchyGreen, fontSize: 'md' }}
                amount={otherDiscountAmount}
              />
            </Total>
          </TotalsRow>
        ))}

      {isLoading ? (
        <CurrencyLineSkeleton />
      ) : (
        <TotalsRow
          accessible
          accessibilityRole="text"
          focusable
          accessibilityLabel={`${t('subtotal')}: ${formatCurrencyForLocale(subtotal)}`}
        >
          <TotalLabel focusable={false}>{t('subtotal')}</TotalLabel>
          <Total focusable={false} testID="subtotal">
            <Currency focusable={false} textProps={{ fontSize: 'md' }} amount={subtotal} />
          </Total>
        </TotalsRow>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  rewardSavingsLabel: {
    marginBottom: spacing.$3,
  },
});
